/**
 * Centralized organization constants — single source of truth for all UI text.
 * Update values here to propagate across every page, component, and PDF.
 */

export const ORG_NAME = "YCK Court RN";
export const ORG_FULL_NAME = "Yio Chu Kang Court Residents' Network";
export const ORG_ADDRESS = "Blk 212 Ang Mo Kio Ave 3, #01-1488, Singapore 560212";
export const ORG_PHONE = "6459 8286";
export const ORG_PHONE_RAW = "64598286";
export const ORG_EMAIL_BOOKINGS = "bookings@yckcourtrn.com";
export const ORG_EMAIL_ADMIN = "yckz2rc@gmail.com";

// Pricing
export const KARAOKE_PRICE_WEEKDAY = 90;
export const KARAOKE_PRICE_WEEKDAY_NIGHT = 90;  // Default until admin changes
export const KARAOKE_PRICE_PREMIUM = 100;
export const BBQ_PRICE_PER_PIT = 20;
export const BBQ_PRICE_BOTH_PITS = 40;
export const KJ_ALLOWANCE_PER_SESSION = 35;
